import { useEffect } from 'react'
import { usePostHog } from '@posthog/react'
import { Trans, useTranslation } from 'react-i18next'
import { CoverCancellationForm } from '@/app/cover-cancellation/cover-cancellation-form'
import ReverCard from '@/ui/components/rever-card'
import { useAppSelector } from '@/redux/hooks'
import { PortalFooter } from '@/ui/layout/portal-footer'

export const CoverCancellationPage = () => {
  const { t } = useTranslation()

  const posthog = usePostHog()

  const settings = useAppSelector(
    (store) => store.settingsApi.settings.response
  )

  useEffect(() => {
    posthog.capture('Cover Cancellation Page Viewed', {
      ecommerceId: settings.ecommerce_id
    })
  }, [posthog, settings.ecommerce_id])

  return (
    <div className="relative flex min-h-screen flex-col bg-white lg:bg-[#f2f2f2]">
      <header className="sticky top-0 z-10 flex min-h-16 w-full items-start justify-center gap-4 border-b border-solid border-neutral-200 bg-white px-4 py-6">
        {settings.branding?.logo_url ? (
          <div className="h-8 max-w-36">
            <img
              src={settings.branding.logo_url}
              height={32}
              width={144}
              alt={settings.branding.title}
              className="h-full w-auto object-contain"
            />
          </div>
        ) : null}
      </header>
      <div className="flex h-full flex-col items-center justify-center">
        <ReverCard className="lg:!p-8">
          <div className="space-y-8">
            <header className="flex flex-col items-center gap-4 text-center">
              <h1 className="max-w-md text-2xl font-semibold leading-tight [text-wrap:balance]">
                {t('cover_cancellation.title')}
              </h1>
              <p className="text-sm font-medium leading-relaxed text-neutral-800 [text-wrap:balance]">
                <Trans
                  i18nKey="cover_cancellation.description"
                  components={{ strong: <strong /> }}
                  values={{ ecommerceName: settings.branding?.title }}
                />
              </p>
            </header>
            <CoverCancellationForm />
          </div>
        </ReverCard>
      </div>
      <div className="mt-auto flex items-center p-4 lg:bg-[#F2F2F2]">
        <PortalFooter />
      </div>
    </div>
  )
}
